import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FingerprintIcon, GiftIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { ForensicMotif } from './ui/ForensicMotif';
import { productBrand, productEdition, productImage, productImageAlt, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} volumi completi`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonus esclusivi`
}];
export function Hero() {
  const scrollToOffer = () => document.getElementById('offerta')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-navy" data-id="element-84" data-mp="s9gh60r02i8p">
      <ForensicMotif side="right" data-id="element-85" data-mp="nb6ktmtjhbli" />
      <div className="flex h-1 w-full" aria-hidden="true" data-id="element-86" data-mp="nbydaoruat7k">
        <span className="flex-1 bg-navy-light" data-id="element-87" data-mp="3d2lb3gldnd2t" />
        <span className="w-24 bg-gold" data-id="element-88" data-mp="3cz5to748dry8" />
        <span className="flex-1 bg-navy-light" data-id="element-89" data-mp="3825ywscu0bmf" />
      </div>

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-10 text-center lg:pb-20 lg:pt-14" data-id="element-90" data-mp="384s4wnk2qj2j">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-gold/50 bg-navy-light/70 px-4 py-2 text-[11px] font-bold uppercase tracking-[.14em] text-ivory sm:text-xs" data-id="element-91" data-mp="3j6fx1mlet7c9">
          <FingerprintIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-92" data-mp="30ggab6d1k4c0" /> {productBrand} · {productEdition}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto mt-8 max-w-3xl" data-id="element-93" data-mp="2qjv4wjx40r7n">
          <div className="absolute inset-[8%] -z-10 rounded-full" style={{
          background: 'radial-gradient(closest-side, rgba(201,162,74,0.35), rgba(201,162,74,0.12) 55%, transparent 100%)'
        }} aria-hidden="true" data-id="element-94" data-mp="2hlj8g19kaz7a" />
          <img src={productImage} alt={productImageAlt} className="mx-auto w-full drop-shadow-[0_0_28px_rgba(201,162,74,0.35)]" data-id="element-95" data-mp="nat8vfsf4smt" />
        </motion.div>

        <div className="mt-8" data-id="element-96" data-mp="ichwoyeni61f">
          <Button onClick={scrollToOffer} arrow className="w-full sm:w-auto" data-id="element-97" data-mp="dd592bfyguxs">
            Voglio l&apos;Edizione Docenti
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-ivory" data-id="element-98" data-mp="1b0ds7zshhrwm">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-gold/30 bg-navy-light/70 px-3 py-2" data-id="element-99" data-mp="111ycesywq52f">
              <Icon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-100" data-mp="x0l328wlvjqr" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}